import { Button, FormContentIsland, Grid, HookForm } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCardQuery, useCardUpdateSpendingStrategyMutation } from '../../../api/cards';
import { useCallback, useEffect } from 'react';
import { Route } from '../../../routes/account.cards_.$cardId_.account';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { AccountField } from '../../Field/AccountField';
import { useAccountsQuery } from '../../../api/accounts';
import { useForm } from 'react-hook-form';
import { ApiCardUpdateSpendingStrategyRequest } from '../../../openapi';
import { useFormError } from '../../../hooks/useFormError';

type CardAccountFormValues = ApiCardUpdateSpendingStrategyRequest;

export function CardAccountPage() {
  const { t } = useTranslation();
  const { cardId } = Route.useParams();
  const cardQuery = useCardQuery({ cardId });
  const accountsQuery = useAccountsQuery();
  const mutation = useCardUpdateSpendingStrategyMutation(cardId);
  const navigate = Route.useNavigate();

  const form = useForm<CardAccountFormValues>({
    defaultValues: cardQuery.data?.spendingStrategy,
  });

  useFormError(form, 'accountId', mutation.error);
  useEffect(() => {
    if (mutation.isSuccess) {
      navigate({ to: `/account/cards/${cardId}`, params: { cardId } });
    }
  }, [mutation.isSuccess, navigate, cardId]);

  useEffect(() => {
    if (cardQuery.data) {
      form.reset(cardQuery.data.spendingStrategy);
    }
  }, [cardQuery.data, form]);

  const handleSubmit = useCallback(
    (values: CardAccountFormValues) => {
      mutation.mutate(values);
    },
    [mutation],
  );

  return (
    <HookForm form={form} onSubmit={handleSubmit}>
      <MainLayout
        title={
          <MainBreadcrumbs
            title={t('Card account')}
            parent={{
              to: '/account/cards/$cardId',
              params: { cardId },
              title: cardQuery.data?.name,
              loading: cardQuery.isPending,
            }}
          />
        }
        compact
      >
        <Grid size={12}>
          <FormContentIsland title={t('Update account')}>
            <AccountField
              name="accountId"
              label={t('Account')}
              accounts={accountsQuery.data}
              loading={accountsQuery.isPending}
            />
          </FormContentIsland>
        </Grid>
        <Grid size={12}>
          <Button type="submit" size="large" color="primary" loading={mutation.isPending} fullWidth>
            {t('Update')}
          </Button>
        </Grid>
      </MainLayout>
    </HookForm>
  );
}
